<button mdMainButton="dark" (click)="openOnRequestConfirmationModal()">
    {{ "On Request" | translate }}
</button>
<ng-template #confirmationModal let-modal>
    <div class="trv-modal-header">
        <h4 class="trv-modal-title">
            {{ "Make a travel request" | translate }}
        </h4>
        <button
            type="button"
            class="btn-close"
            aria-label="Close"
            (click)="modal.dismiss('Cross click')"
        ></button>
    </div>
    <div class="trv-modal-body">
        <p>{{ "Create a request to book this travel deal?" | translate }}</p>
        {{
            "You will be contacted by our travel team to confirm the booking."
                | translate
        }}
    </div>
    <div class="trv-modal-footer">
        <button
            mdMainButton="light"
            type="button"
            (click)="confirmBookingRequest()"
        >
            {{ "Proceed" | translate }}
        </button>
        <button
            type="button"
            mdMainButton="dark"
            (click)="modal.close('Cancel click')"
        >
            {{ "Cancel" | translate }}
        </button>
    </div>
</ng-template>
<ng-template #successModal let-modal>
    <div class="trv-modal-header">
        <h4 class="trv-modal-title">
            {{ "Travel request submitted" | translate }}
        </h4>
        <button
            type="button"
            class="btn-close"
            aria-label="Close"
            (click)="modal.dismiss('Cross click')"
        ></button>
    </div>
    <div class="trv-modal-body">
        <p>{{ "Thank you! Your request has been submitted." | translate }}</p>
        {{ "Our team will contact you as soon as possible." | translate }}
    </div>
    <div class="trv-modal-footer">
        <button
            mdMainButton="light"
            class="trv-ok-button"
            type="button"
            (click)="modal.dismiss('OK')"
        >
            {{ "OK" | translate }}
        </button>
    </div>
</ng-template>
